import {Col, Icon, Row, Space, Typography} from "@bezlimit/bezlimit-ui";
import _ from "lodash";
import "./style.scss";
import {useTranslation} from "react-i18next";
import NumberFormat from "react-number-format";
//core
import date from "../../../../../../core/functions/date";
import {IItems} from "../../../../../../core/models/Bonus";

const dateFormat: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric"
};

const dateFormatMobile: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric"
};

export default function ItemPaymants({
    item: {created_at, type, status, total_sum, sum, phone, comment, loyalty}
}: IProps) {
    const {t} = useTranslation();

    return (
        <Typography as="div" className="bl-list-payments">
            <Row>
                <Col md={0} xs={24}>
                    <Typography as="div" className="date-format-mobile">
                        <Typography size={14} className="date-format-mobile-text">
                            {date(created_at, dateFormatMobile)}
                        </Typography>
                    </Typography>
                </Col>
                <Col md={4} xs={0}>
                    <Typography size={17}>{date(created_at, dateFormat)}</Typography>
                </Col>
                <Col md={4} xs={0}>
                    <Space>
                        {!_.isNil(loyalty) && !_.isNil(loyalty.code) ? (
                            <Icon name={`loyalty_${loyalty.code}`} size="16" />
                        ) : null}
                        <Typography size={17} color="rgba(255, 255, 255, 0.5)">
                            {!_.isNil(loyalty) ? loyalty.name : null}
                        </Typography>
                    </Space>
                </Col>
                <Col md={4} xs={0}>
                    {_.isEqual(type, "gift") ? (
                        <Typography size={17}>{comment}</Typography>
                    ) : (
                        <Typography size={17}>{phone}</Typography>
                    )}
                </Col>
                <Col md={5} xs={0}>
                    {_.isEqual(type, "gift") ? (
                        <Space>
                            <Icon name="lightning2" size="14" />
                            <Typography size={17}>{t("Выплачен")}</Typography>
                        </Space>
                    ) : _.isEqual(status, 2) ? (
                        <Space>
                            <Icon name="status_active" size="14" />
                            <Typography size={17}>{t("Активен")}</Typography>
                        </Space>
                    ) : _.isEqual(status, 3) ? (
                        <Space>
                            <Icon name="status_blocked" size="14" />
                            <Typography size={17}>{t("Заблокирован")}</Typography>
                        </Space>
                    ) : _.isEqual(status, 4) ? (
                        <Space>
                            <Icon name="status_completed" size="14" />
                            <Typography size={17}>{t("Выплачен")}</Typography>
                        </Space>
                    ) : (
                        <Space>
                            <Icon name="status_process" size="14" />
                            <Typography size={17}>{t("Перевыпущен")}</Typography>
                        </Space>
                    )}
                </Col>
                <Col md={0} xs={24} className="col-mobile-status-payments">
                    {_.isEqual(type, "gift") ? (
                        <Typography size={17}>{comment}</Typography>
                    ) : (
                        <Typography size={17}>{phone}</Typography>
                    )}
                    {_.isEqual(type, "gift") ? (
                        <Icon name="lightning2" size="10" />
                    ) : (
                        <img src={`status_${status}.png`} alt="" />
                    )}
                </Col>
                <Col md={0} xs={12}>
                    <Typography
                        size={14}
                        className="date-format-mobile-payments"
                        color="rgba(255, 255, 255, 0.5)"
                    >
                        {date(created_at, dateFormat)}
                    </Typography>
                </Col>
                <Col md={3} xs={12} className="col-mobile-payments-sum">
                    <Typography as="div" className="mobile-payments-sum">
                        <Typography size={24} className="list-total-sum">
                            <NumberFormat
                                thousandSeparator=" "
                                displayType="text"
                                value={sum.toFixed(2)}
                            />
                        </Typography>
                        <Typography
                            className="mobile-text-payments"
                            size={14}
                            color="rgba(255, 255, 255, 0.5)"
                        >
                            {t("Накоплено")}
                        </Typography>
                    </Typography>
                </Col>
                <Col md={3} xs={12}>
                    <Space className="total-sum-sum-ikon">
                        <Typography size={24} className="total-sum-sum">
                            <NumberFormat
                                thousandSeparator=" "
                                displayType="text"
                                value={(total_sum - sum).toFixed(2)}
                            />
                        </Typography>
                        <Typography>
                            <Icon name="Polygon5" size="8" />
                        </Typography>
                    </Space>
                </Col>
            </Row>
        </Typography>
    );
}

interface IProps {
    item: IItems;
    // period: RangeValue<moment.Moment>;
    // activeKey: string;
}
